export default "__VITE_ASSET__BKukn6ru__"